import { h, render } from "preact";
import { fetchCatalogs } from "../global/storefront/catalogs";
import { useAsync } from "../global/hooks/useAsync";
import { CatalogCard, SkeletonCard } from "../global/catalog-card/catalog-card";

const CARD_SIZES = "(min-width: 1024px) 25vw, (min-width: 768px) 33vw, 50vw";
const CARD_IMAGE_WIDTH = 600;
const SKELETON_COUNT = 8;

function SkeletonGrid() {
  return (
    <div class="browse-catalogs__items">
      {Array.from({ length: SKELETON_COUNT }, (_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}

function CatalogList() {
  const { status, data } = useAsync(fetchCatalogs);

  if (status === "loading") return <SkeletonGrid />;
  if (status === "error") {
    return <p class="browse-catalogs__status body-1">Unable to load catalogs.</p>;
  }

  const catalogs = (data || []).filter(
    (catalog) => catalog.title && catalog.date,
  );

  if (!catalogs.length) {
    return <p class="browse-catalogs__status body-1">No catalogs found.</p>;
  }

  return (
    <div class="browse-catalogs__items">
      {catalogs.map((catalog) => (
        <CatalogCard
          key={catalog.id}
          catalog={catalog}
          sizes={CARD_SIZES}
          imageWidth={CARD_IMAGE_WIDTH}
        />
      ))}
    </div>
  );
}

class BrowseCatalogs extends HTMLElement {
  connectedCallback() {
    this.container = this.querySelector("[data-container]");
    render(<CatalogList />, this.container);
  }

  disconnectedCallback() {
    render(null, this.container);
  }
}

if (!customElements.get("browse-catalogs")) {
  customElements.define("browse-catalogs", BrowseCatalogs);
}
